<style lang="scss" scoped>
@include component(organisation-notice) {
	background: purple;
	color: white;
	font-weight: 500;
	display: none;
	@include media-breakpoint-up(md) {
		display: block;
	}
	a {
		color: white !important;
		font-weight: 700;
	}
	@include option(expired) {
		background: black;
	}
}
@include component(test-notice) {
	background: #dd2d35;
	color: white;
	font-weight: 500;
	display: none;
	@include media-breakpoint-up(md) {
		display: block;
	}
	a {
		color: white !important;
		font-weight: 700;
	}
	@include option(expired) {
		background: black;
	}
}
.copy {
	display: none;
	@include media-breakpoint-up(md) {
		display: block;
	}
	margin-top: 30px;
	text-align: center;
	a {
		display: block;
		margin-top: 10px;
	}
}
</style>

<template lang="pug">
div
    #layout(v-if="$route.meta.layout !== false")
        .organisation-notice(v-if="isOrgnaisationAdminLoggedInAsSchool")
             .container
                .row
                    .col-12.col-md-9.pt-4.pb-4
                        | You are logged into an organisation account
                    .col-12.col-md-3.text-right
                        a.p-4.d-inline-block(style="padding-right:0 !important", href="#", @click="backToOrganisation") Back to organisation
        layout-header
        router-view
        layout-footer
    template(v-else)
        router-view
</template>
<script>
import LayoutHeader from "@/components/global/Header.vue";
import LayoutFooter from "@/components/global/Footer.vue";
import _ from "lodash";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import cookie from "js-cookie";

export default {
	components: {
		LayoutHeader,
		LayoutFooter
	},
	data() {
		return {
			errors: globalErrors,
			expiresIn: null,
			expired: false,
			loadingStarted: false
		};
	},
	computed: {
		isOrgnaisationAdminLoggedInAsSchool() {
			return cookie.get("organisation-school");
		}
	},
	watch: {
		errors() {
			if (this.errors.length) {
				_.each(this.errors, error => {
					this.$message({
						type: "error",
						message: error.message,
						duration: 10000
					});
				});
			}
		}
	},
	mounted() {
		if (this.$route.query.time) {
			let timer = () => {
				this.expiresIn = moment(this.$route.query.time * 1000).fromNow();
				this.expired = moment(this.$route.query.time * 1000) < moment();
			};
			timer();
			setInterval(timer, 1000);
		}
	},
	methods: {
		backToOrganisation() {
			cookie.remove("organisation-school");
			window.location.href = "/";
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/private/components/pages/Layout.vue